import { render } from "./problem-view.vue?vue&type=template&id=412ab64c&scoped=true"
import script from "./problem-view.vue?vue&type=script&lang=js"
export * from "./problem-view.vue?vue&type=script&lang=js"

import "./problem-view.vue?vue&type=style&index=0&id=412ab64c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412ab64c"]])

export default __exports__